export interface BulkUpdateResponse {
  isFullySuccessful: boolean
  recordsRequested: number
  recordsSuccessfullyUpdated: number
  failures: string[]
}

export interface NewAddressObject {
  newAddressEntered: string
  newAddressKnown: string
  newAddressCoordinates: {
    lat: number
    lon: number
  }
}

export const RECORD_BULK_UPDATE = 'RECORD_BULK_UPDATE'
export const recordBulkUpdate = (
  accountId: string,
  projectId: string,
  moduleName: string,
  fieldName: string,
  newValue: string | NewAddressObject,
  recordIds: string[],
  showSuccessNotification: (response: BulkUpdateResponse) => void,
  showFailureNotification: () => void,
  allowOverwrite?: boolean
) => ({
  type: RECORD_BULK_UPDATE,
  accountId,
  projectId,
  moduleName,
  fieldName,
  newValue,
  recordIds,
  showSuccessNotification,
  showFailureNotification,
  allowOverwrite
})

export interface RecordBulkUpdateAction {
  type: typeof RECORD_BULK_UPDATE
  accountId: string
  projectId: string
  moduleName: string
  fieldName: string
  newValue: string | NewAddressObject
  recordIds: string[]
  showSuccessNotification: (response: BulkUpdateResponse) => void
  showFailureNotification: () => void
  allowOverwrite?: boolean
}
